import { buildMinisterMessage } from '../services/ai.js';

export function handleMinisterMessage() {
  window.logToConsole("🧠 News Agent online. Harvesting real-time crypto updates...");
  
  buildMinisterMessage().then(msg => {
    window.logToConsole(`🧠 NEWS AGENT REPORT:\nGreetings citizen. Here's today's crypto intel.\n\n${msg}`);
  }).catch(error => {
    console.error("Minister error:", error);
    window.logToConsole("🧠 ERROR: Could not retrieve latest news.");
  });
}